import React from 'react';

const HighestIvfPattern = ({ className }) => {
  return (
    <svg
      className={className}
      width="1440"
      height="100%"
      viewBox="0 0 1440 400"
      preserveAspectRatio="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_384_5254)">
        <rect width="1440" height="413" fill="white" />
        <g opacity="0.65">
          <path d="M-5 23C2.5 30.1259 53 64.3302 -2 107.086C-1.83333 111.519 0.9 118.772 10.5 112.311L49 77.6318C59.5 68.1306 85.2 56.7292 104 87.133C108.833 93.6255 113.4 110.601 93 126.563L-5 220.15V247.703L30.5 215.874C48.8333 204.948 89.2 194.496 104 240.102C109 248.02 112 269.936 84 294.259L30.5 344.615C25.1667 351.583 19.6 363.428 40 355.066L130.5 270.031C140 260.055 162.7 246.088 177.5 270.031C182.667 276.365 188.5 292.264 170.5 305.185L108 364.568C104 371.852 100.7 384.235 119.5 375.494C136.167 361.717 177.6 344.14 210 384.045L243 414.924H-5V247.703V220.15V23Z" fill="#7F4A9B" />
          <line x1="43.3877" y1="118.51" x2="114.999" y2="190.122" stroke="white" stroke-width="2" />
          <line x1="43.3877" y1="242.025" x2="114.999" y2="313.637" stroke="white" stroke-width="2" />
          <line x1="43.3877" y1="267.679" x2="114.999" y2="339.291" stroke="white" stroke-width="2" />
          <line x1="56.3877" y1="368.391" x2="179.999" y2="491.999" stroke="white" stroke-width="2" />
        </g>
        <g opacity="0.23">
          <path d="M1447.27 336.853C1441 330.584 1398.79 300.497 1444.76 262.888C1444.62 258.988 1442.33 252.609 1434.31 258.292L1402.13 288.797C1393.36 297.154 1371.88 307.183 1356.17 280.439C1352.13 274.728 1348.31 259.796 1365.36 245.755L1447.27 163.434V139.197L1417.6 167.194C1402.27 176.806 1368.54 185.999 1356.17 145.883C1351.99 138.918 1349.48 119.64 1372.88 98.2447L1417.6 53.9497C1422.05 47.8208 1426.71 37.4018 1409.66 44.7564L1334.02 119.556C1326.08 128.332 1307.11 140.617 1294.74 119.556C1290.42 113.985 1285.55 99.9998 1300.59 88.6335L1352.83 36.3989C1356.17 29.9914 1358.93 19.0988 1343.21 26.7877C1329.28 38.9061 1294.66 54.3676 1267.58 19.2659L1240 -7.89612H1447.27V139.197V163.434V336.853Z" fill="#7F4A9B" />
          <line x1="1452.99" y1="205.51" x2="1399.5" y2="258.999" stroke="white" stroke-width="2" />
          <line x1="1452.99" y1="96.8624" x2="1399.5" y2="150.351" stroke="white" stroke-width="2" />
          <line x1="1452.99" y1="74.297" x2="1399.5" y2="127.785" stroke="white" stroke-width="2" />
          <line x1="1442.12" y1="-14.2929" x2="1325.95" y2="101.877" stroke="white" stroke-width="2" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_384_5254">
          <rect width="1440" height="413" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HighestIvfPattern;